import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { setupFunnelStorageSync } from './services/funnel-cleanup.service'
import './styles/index.css'

import * as Sentry from "@sentry/react";

const sentryEnvironment = (): string => {
  const host = window.location.hostname;
  if (host === 'alps2alps.skipasser.com') {
    return 'production';
  }
  if (host === 'stage.a2a.skipasser.com') {
    return 'stage';
  }
  return 'development';
};

setupFunnelStorageSync();

Sentry.init({
  dsn: "https://e14c92465d1d7dedfe5fe0ded3fb5f55@o4510317199884288.ingest.de.sentry.io/4512322832367696",
  environment: sentryEnvironment(),
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
